module.exports = __webpack_public_path__ + "Montserrat-Regular-b0322f2faed575161a052b5af953251a.woff";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/fonts/montserrat/Montserrat-Regular.woff
// module id = 874
// module chunks = 86